import { Heading } from "monday-ui-react-core";
import styled from "styled-components";

import acliLogo from "@/assets/img/acli.webp";

interface Props {
  message: string;
}

export function NoLicense({ message }: Props) {
  return (
    <NoLicenseWrapper>
      <img src={acliLogo} alt="CLI - Automate Actions Logo" />
      <Heading type={Heading.types.h3} value="CLI - Automate Actions - License required" />
      <LicenseText data-testid="license-block-message">{message}</LicenseText>
    </NoLicenseWrapper>
  );
}

const NoLicenseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-xxl);

  img {
    width: 120px;
  }
`;

const LicenseText = styled.span`
  text-align: center;
  font-size: 16px;
`;
